module.exports = __webpack_public_path__ + "static/img/multiChartView-3.0006e68.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/multiChartView-3.svg
// module id = CUPX
// module chunks = 4